import { FileRouteTypes } from '../routeTree.gen';

export type TRoute = {
  id: 'start_over' | 'refunds' | 'contact_us';
  title: string;
  to: string;
  icon: string;
  secondIcon?: string;
  target?: string;
};

export type TPath = FileRouteTypes['to'];

export type TRefundOption = {
  heading: string;
  title: ERefundOption;
  time: string;
  description: string;
  action: string;
  isRecommended: boolean;
  path: TPath;
  allowFor: EClaimType[];
  refundMethod: number;
  limit?: number;
};

export enum ERefundOption {
  DIRECT_DEPOSIT = 'Direct Deposit',
  GIFT_CARD = 'Gift Card',
  DONATE_REFUND = 'Donate Payment',
  CHECK_MAIL = 'Check by Mail',
  DIGITAL_PAYMENTS = 'Venmo/PayPal',
}

export enum EClaimType {
  EMAIL = 'Email',
  LETTER = 'Letter',
}

export enum ERefundMethods {
  ACH = 7,
  CHECK = 5,
  GIFTCARD = 4,
  DONATION = 6,
  PAYPAL = 2,
  VENMO = 3,
}

export type TGiftOrDonation = 'giftcards' | 'donations' | 'digitalpayments';

export type TLetterFlowSteps = {
  title: string;
  description: string;
  isActive?: boolean;
  path?: string;
};

export type TLetterFlowOption = {
  tag: 'digital' | 'paper check';
  title: string;
  description: string;
  method: 'direct-deposit' | 'refund-email';
};
